<div class="more-info-list">
  <lx-price-lists-portal-more-info-title [title]="title"></lx-price-lists-portal-more-info-title>
  <div class="more-info-list__item" *ngFor="let item of moreInfoItems">
    <div class="more-info-list__item__name">{{ item.name }}</div>
    <div class="more-info-list__item__price">{{ item.price | lxPrice }}</div>
  </div>
</div>
